export default "__VITE_ASSET__BnSZbPcc__"